import {useMaterialStorageHistory} from '@domain/material-storage'
import {useUpmPlantContext} from '@hconnect/upm'
import {Moment} from 'moment-timezone'

import type {MomentRange} from '../types'
import {getStoragesFromHistory, toRecord} from '../utils'

interface HistoryStoragesWithMaterialQueryParams {
  timeFrame: MomentRange
  date?: Moment
  throwOnError?: boolean
}

export const useHistoryStoragesByIdQuery = ({
  timeFrame: [from, to],
  date,
  throwOnError = true
}: HistoryStoragesWithMaterialQueryParams) => {
  const {plantId} = useUpmPlantContext()
  return useMaterialStorageHistory({
    plantId,
    from: from.toISOString(),
    to: to.toISOString(),
    options: {
      select: (storagesHistory) => {
        return toRecord(getStoragesFromHistory(storagesHistory, date ?? to), 'id')
      },
      throwOnError
    }
  })
}
